import {AxiosResponse} from "axios";

import {axios} from "@/src/modules/core/lib";

import type {DashboardOverview, DashboardOverviewFilters} from "../types";

const PATH = "dashboard/overview";

class DashboardApi {
  /**
   * `GET /api/v1/dashboard/overview`
   *
   * `context_property_id[]` scopes activity sections only (kpis, time_series,
   * breakdowns). Management and emails are always company-wide on the
   * backend, regardless of this filter.
   */
  getOverview(
    filters: DashboardOverviewFilters,
  ): Promise<AxiosResponse<DashboardOverview>> {
    const params = new URLSearchParams();
    params.append("period", filters.period);
    for (const id of filters.context_property_ids) {
      params.append("context_property_id[]", String(id));
    }

    return axios({
      url: PATH,
      method: "get",
      params,
    });
  }
}

export const dashboardApi = new DashboardApi();
